import {useIntl} from 'react-intl';
import React, {useRef, useState} from 'react';
import ListIcon from '@material-ui/icons/List';
import GridIcon from '@material-ui/icons/Apps';
import {Button, IconButton} from '@material-ui/core';

import {DataViewerLabel} from '../../DataViewer/DataViewerLabel';
import {ViewId, FileItem, FileViewer, ImageAdornment} from '../FileViewer/FileViewer';

import './DeploymentDataReview.scss';

export type DataReviewProps = {
  title: string;
  projectId: string;
  fileItems: FileItem[];
  onDelete?(): void;
  onClearAll?: () => void;
  onSelectAll?: () => void;
  onSelect?(id: string): void;
  onChange?(files: File[]): void;
};

export const DeploymentDataReview = ({
  title,
  projectId,
  fileItems,
  onSelect,
  onClearAll,
  onSelectAll,
}: DataReviewProps) => {
  const intl = useIntl();
  const parentRef = useRef<HTMLDivElement>(null);
  const [view, setView] = useState<ViewId>('grid');

  return (
    <div className="deployment-data-review" ref={parentRef}>
      <div className="deployment-data-review__content">
        <h4>{title}</h4>
        <div className="deployment-data-review__menu">
          <DataViewerLabel
            count={fileItems.length}
            className="deployment-data-review__label"
            label={intl.formatMessage({id: 'dataPrep.review.total.images'})}
          />
          <IconButton
            size="medium"
            onClick={() => {
              setView(view === 'grid' ? 'list' : 'grid');
            }}
          >
            {view === 'grid' ? <ListIcon /> : <GridIcon />}
          </IconButton>
        </div>
        <div className="deployment-data-review__sub-menu">
          <Button color="primary" onClick={() => onSelectAll?.()}>
            {intl.formatMessage({id: 'dataPrep.review.selectAll'})}
          </Button>
          <Button
            color="primary"
            onClick={() => onClearAll?.()}
            disabled={!fileItems.some(item => item.selected)}
          >
            {intl.formatMessage({id: 'dataPrep.review.deselectAll'})}
          </Button>
        </div>
        <FileViewer
          view={view}
          items={fileItems}
          origin="deployment"
          projectId={projectId}
          onSelect={(id: string) => onSelect?.(id)}
          renderAdornment={({selected, isLocal}) => (
            <ImageAdornment selected={selected} isLocal={isLocal} />
          )}
        />
      </div>
    </div>
  );
};
